<template>
    <div class="relative">
        <div v-if="cause">
            <CauseSingle :click-handler="backToDashboard" :cause="cause" />
        </div>
    </div>
</template>

<script>
import Close from "../components/UI/Close";
import Post from "../components/Post/Post";
import CauseSingle from "../components/Cause/CauseSingle";

export default {
    name: "NpoSingle",
    components: {
        CauseSingle,
        Post,
        Close,
    },

    data() {
        return {
            cause: null,
            bgColor: "#DB8633",
            btnColor: "#F3963C",
            textColor: "#DB8633",
            subTextColor: "#4A4B4D",
            linkColor: "",
            iconColor: "#DB8633",
            savingTagColor: "#90AFAF",
        };
    },

    created() {
        this.$checkAvatar(this.$user("has_avatar"));
    },
    mounted() {
        this.getUserNpo();
    },

    methods: {
        backToDashboard: function () {
            this.$router.push("/dashboard");
        },
        getUserNpo: function () {
            let id = !!this.$route.params.id ? this.$route.params.id : 0;

            this.$http.get(`npos/getdatanpo?npo_id=${id}`).then(res => {
                if (res && res.status !== undefined && res.status) {
                    if (!!res.data.npo && res.data.npo) {
                        this.cause = res.data.npo;
                        this.$setState(
                            "appUrl",
                            !res.data.app_url ? "" : res.data.app_url,
                        );
                    } else {
                        this.backToDashboard();
                    }
                }
            });
        }
    },
};
</script>
